<template>
    <div>
        <highcharts :options="chartOptions"></highcharts>
    </div>
</template>

<script>
    import {Chart} from 'highcharts-vue';
    export default {
        name: "LineChart",
        data() {
            return {
                chartType: 'Spline',
                seriesColor: '#6fcd98',
                colorInputIsSupported: null,
                chartOptions: {
                    chart: {
                        type: 'area',
                        zoomType: 'x',
                        panning: true,
                        panKey: 'shift',
                        width:340,
                        height: 130,
                        margin:0,
                        scrollablePlotArea: {

                        }
                    },
                    title: {
                        text: ''
                    },
                    series: [{
                        data: [5, 7, 8, 5, 6, 5, 9, 11,15,13,12,10,12,16,14,10, 8,10,11,13,15,12],
                        color: '#8c76b7',
                        fillOpacity: 0.1,
                        marker: {
                            enabled: false
                        }
                    }],
                    xAxis: {
                        visible: false,
                        minTickInterval: 5,
                        minPadding:0,
                        maxPadding:0

                    },
                    yAxis: {
                        visible: false

                    },
                    legend: {'enabled': false},
                    credits: {'enabled': false},
                    'tooltip': {'enabled': false, 'shared': false},

                }
            }
        },
        components:{
            highcharts: Chart

        }

    }
</script>

<style scoped>
    HighChartsVue {
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/components/chart/LineChart.vue